import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

const VerifyEmailPage = () => {
  const baseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const { id, token } = useParams();
  const[verifyPending, setVerifyPending]= useState(false);
  const[verifySuccess, setVerifySuccess]= useState(false);
  const[verifyError, setVerifyError]= useState(null);

  useEffect(() => {
    getEmail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getEmail = async () => {
    setVerifyPending(true);
    try {
      const path = `/api/user/verify-user-email/${id}/${token}`;
      const url = baseUrl + path;
      const emailResponse = await axios.get(url);
      const message = emailResponse?.data?.message;
      const status = emailResponse?.data?.status;
      setVerifyPending(false);
      if (status === "success") {
        setVerifySuccess(true);
        toast.success("Email Verified Successfully.");
        navigate("/auth/login");
      }
      if (status === "failed") {
        toast.error(message);
      }
    } catch (error) {
      setVerifyPending(false);
      const message = error.message;
      setVerifyError(message)
      toast.error(message);
    }
  };

  return (
    <div className="h-screen bg-[#fbf7f7] p-6 pt-12 text-center">
      {verifyPending && <h5 className="text-custom_h6 animate-pulse flex justify-center items-center sm:text-custom_h5 text-main_color">
        Verifying your e-mail 
        <div className="animate-bounce ml-1">.</div>
        <div className="animate-bounce">.</div>
        <div className="animate-bounce ">.</div>
      </h5>}
      {!verifyPending && verifySuccess && <h5 className="text-custom_h6 text-state_color_success">Email Verified Successfully</h5>}
      {!verifyPending && verifyError && <h5 className="text-custom_h6 text-state_color_error">{verifyError}</h5>}
    </div>
  );
};

export default VerifyEmailPage;
